var url = "";
var proj = "";
var event_url = "";
var meta_info = "";

if (
  window.location.host === "mytiketi.com" ||
  window.location.host === "mytiketi.com" ||
  window.location.host === "www.mytiketi.com" ||
  window.location.host === "development.mytiketi.com"
) {
  url = "https://api.mytiketi.com";
  proj = "myticketi";
  meta_info = {
    // Result: My Page Title ← My Site
    title: "Wanasa Time",
    // If a child changes the title to "My Other Page Title",
    // it will become: My Other Page Title ← My Site
    titleTemplate: null,
    // Define meta tags here.
    meta: [
      { "http-equiv": "Content-Type", content: "text/html; charset=utf-8" },
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "description",
        content:
          "Book Movie ticket online in nairobi, Watch the latest movie trailers, book movie tickets at your nearest theatres in nairobi. Online movie booking website and app"
      },
      {
        name: "keywords",
        content:
          "book movie tickets, Movie tickets, book tickets online , book movie tickets online, buy movie tickets online, century imax, century cinema garden city, century cinemas junction, century cinemas, century imax garden city, cinemas in nairobi, movie tickets nairobi, kenyabuzz , patahapa, best movie ticket buying platform in kenya"
      }
    ]
  };
} else if (
  window.location.host === "ticketak.com" ||
  window.location.host === "www.ticketak.com"
) {
  meta_info = {
    // Result: My Page Title ← My Site
    title: "Ticketak Cinema",
    // If a child changes the title to "My Other Page Title",
    // it will become: My Other Page Title ← My Site
    titleTemplate: null,
    // Define meta tags here.
    meta: [
      { "http-equiv": "Content-Type", content: "text/html; charset=utf-8" },
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "description",
        content:
          "Book Movie ticket online in nairobi, Watch the latest movie trailers, book movie tickets at your nearest theatres in nairobi. Online movie booking website and app"
      },
      {
        name: "keywords",
        content:
          "book movie tickets, Movie tickets, book tickets online , book movie tickets online, buy movie tickets online, century imax, century cinema garden city, century cinemas junction, century cinemas, century imax garden city, cinemas in nairobi, movie tickets nairobi, kenyabuzz , patahapa, best movie ticket buying platform in kenya"
      }
    ]
  };

  url = "https://api.ticketak.com";
  proj = "ticketak";
} else if (window.location.host === "prod.ticketak.com") {
  meta_info = {
    // Result: My Page Title ← My Site
    title: "Ticketak Cinema",
    // If a child changes the title to "My Other Page Title",
    // it will become: My Other Page Title ← My Site
    titleTemplate: null,
    // Define meta tags here.
    meta: [
      { "http-equiv": "Content-Type", content: "text/html; charset=utf-8" },
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "description",
        content:
          "Book Movie ticket online in nairobi, Watch the latest movie trailers, book movie tickets at your nearest theatres in nairobi. Online movie booking website and app"
      },
      {
        name: "keywords",
        content:
          "book movie tickets, Movie tickets, book tickets online , book movie tickets online, buy movie tickets online, century imax, century cinema garden city, century cinemas junction, century cinemas, century imax garden city, cinemas in nairobi, movie tickets nairobi, kenyabuzz , patahapa, best movie ticket buying platform in kenya"
      }
    ]
  };

  url = "http://dev-api1.ticketak.com";
  proj = "ticketak";
} else if (window.location.host === "dev.ticketak.com") {
  url = "https://dev-api.ticketak.com";
  //url = 'https://api.mytiketi.com'
  proj = "ticketak";

  meta_info = {
    // Result: My Page Title ← My Site
    title: "Ticketak Cinema",
    // If a child changes the title to "My Other Page Title",
    // it will become: My Other Page Title ← My Site
    titleTemplate: null,
    // Define meta tags here.
    meta: [
      { "http-equiv": "Content-Type", content: "text/html; charset=utf-8" },
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "description",
        content:
          "Book movie tickets online in UAE, UAE's first online aggregator movie ticket booking platform, also available on android & iOS. Book your movie tickets now"
      },
      {
        name: "keywords",
        content:
          "movie tickets, book movie tickets, book movie tickets at vox, vox cinema, novo cinema, star cinema, oscar cinema, cinema akil, reel cinema, latest movie tickets, movie tickets in uae, theatres in uae, cinemas in uae, watch movie in cinemas, book cinema tickets online, online movie ticket booking, movie tickets online in uae, watch new hindi movies, watch malayalam movies, watch english movies, movie tickets, book movie tickets uae, uae movie ticket booking app"
      }
    ]
  };
} else if (
  window.location.host === "prod.mytiketi.com" ||
  window.location.host === "dev.mytiketi.com"
) {
  // url = 'https://api.mytiketi.com'
  url = "https://apidevelopment.mytiketi.com";

  //url = 'https://dapi.mytiketi.com'
  //proj = "ticketak"
  proj = "myticketi";
  meta_info = {
    // Result: My Page Title ← My Site
    title: "Wanasa Time",
    // If a child changes the title to "My Other Page Title",
    // it will become: My Other Page Title ← My Site
    titleTemplate: null,
    // Define meta tags here.
    meta: [
      { "http-equiv": "Content-Type", content: "text/html; charset=utf-8" },
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "description",
        content:
          "Book Movie ticket online in nairobi, Watch the latest movie trailers, book movie tickets at your nearest theatres in nairobi. Online movie booking website and app"
      },
      {
        name: "keywords",
        content:
          "book movie tickets, Movie tickets, book tickets online , book movie tickets online, buy movie tickets online, century imax, century cinema garden city, century cinemas junction, century cinemas, century imax garden city, cinemas in nairobi, movie tickets nairobi, kenyabuzz , patahapa, best movie ticket buying platform in kenya"
      }
    ]
  };
} else if (window.location.host.includes("localhost") && false) {
  url = "http://localhost:4080";
  //url = 'https://dev-api.ticketak.com'
  //url = 'https://api.ticketak.com'
  //url = 'https://dapi.mytiketi.com'

  //proj = "ticketak"
  proj = "myticketi";

  meta_info = {
    // Result: My Page Title ← My Site
    title: "Wanasa Time",
    // If a child changes the title to "My Other Page Title",
    // it will become: My Other Page Title ← My Site
    titleTemplate: null,
    // Define meta tags here.
    meta: [
      { "http-equiv": "Content-Type", content: "text/html; charset=utf-8" },
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "description",
        content:
          "Book Movie ticket online in nairobi, Watch the latest movie trailers, book movie tickets at your nearest theatres in nairobi. Online movie booking website and app"
      },
      {
        name: "keywords",
        content:
          "book movie tickets, Movie tickets, book tickets online , book movie tickets online, buy movie tickets online, century imax, century cinema garden city, century cinemas junction, century cinemas, century imax garden city, cinemas in nairobi, movie tickets nairobi, kenyabuzz , patahapa, best movie ticket buying platform in kenya"
      },
      { property: "og:url", content: "https://website-wanastime.brij.tech" }
    ]
  };
} else {
  //url = 'https://apidevelopment.mytiketi.com'
  //url = 'http://dev-api1.ticketak.com'
  /*og*/

  // if (window.location.host.includes("localhost")){
  // event_url = "https://event.wanasatime.com";
  // }else{
  //   event_url = "https://event.wanasatime.com";
  // }

  if (window.location.host.includes("localhost")) {
    event_url = "http://localhost:8080";
    url = "https://api-wanastime.wanasatime.com";
  } else if (
    window.location.host.includes("wanasadev.enpointe.io") ||
    window.location.host.includes("localhost")
  ) {
    event_url = "https://wanasaeventdev.enpointe.io";
    url = "https://wanasamovieapidev.enpointe.io";
  } else {
    event_url = "https://event.wanasatime.com";
    url = "https://api-wanastime.wanasatime.com";
  }

  //url = 'https://dev-api.ticketak.com'
  //url = 'https://api.ticketak.com'
  //url = 'https://dapi.mytiketi.com'
  //url = 'https://wanasaevent.enpointe.io';

  //proj = "ticketak"
  proj = "myticketi";

  meta_info = {
    // Result: My Page Title ← My Site

    title:
      "Online Ticket Booking for Movies and Events near You in Bahrain - Wanasatime",
    // If a child changes the title to "My Other Page Title",
    // it will become: My Other Page Title ← My Site
    titleTemplate: null,
    // Define meta tags here.

    meta: [
      { "http-equiv": "Content-Type", content: "text/html; charset=utf-8" },
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "description",
        content:
          "Online ticket booking for all the movies and events showing near you in Bahrain | Wanasatime, Cinema Bahrain"
      },
      {
        name: "keywords",
        content:
          "online ticket booking, cinema bahrain, Cinema online booking, cinema ticket booking, Movie Trailers, Reviews"
      },
      { property: "og:url", content: "https://www.wanasatime.com" }
    ]
  };

  /*meta_info = {
    // Result: My Page Title ← My Site
    title: 'Ticketak Cinema',
    // If a child changes the title to "My Other Page Title",
    // it will become: My Other Page Title ← My Site
    titleTemplate: null,
    // Define meta tags here.
    meta: [
      { 'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { name: 'description', content: "Book movie tickets online in UAE, UAE's first online aggregator movie ticket booking platform, also available on android & iOS. Book your movie tickets now" },
      { name: 'keywords', content: 'movie tickets, book movie tickets, book movie tickets at vox, vox cinema, novo cinema, star cinema, oscar cinema, cinema akil, reel cinema, latest movie tickets, movie tickets in uae, theatres in uae, cinemas in uae, watch movie in cinemas, book cinema tickets online, online movie ticket booking, movie tickets online in uae, watch new hindi movies, watch malayalam movies, watch english movies, movie tickets, book movie tickets uae, uae movie ticket booking app' }
    ]
  };*/
}

//export const BASEURL = url
//Ticketak
//export const URL_BASE = window.testVariable;
//export const BASEURL = 'https://api2.ticketak.com'; //for upload ticketak
//export const BASEURL = 'http://devapi.mytiketi.com'; //for upload MyTiketi
export const URL_BASE = url;
export const EVENT_URL = event_url;
//Ticketak
//export const URL_BASE = 'http://api.mytiketi.com'

export const PROJECT = proj;
//export const PROJECT = "myticketi"

//export const METAWEBSITE = {};
//export const METAORGANIZATION = {};

export const metaInfo = meta_info;

export const METAWEBSITE = {
  "@context": "http://schema.org",
  "@type": "WebSite",
  name: PROJECT == "ticketak" ? "Ticketak" : "Mytiketi",
  url:
    PROJECT == "ticketak"
      ? "https://ticketak.com/"
      : "https://www.mytiketi.com/"
};

export const METAORGANIZATION = {
  "@context": "http://schema.org",
  "@type": "Organization",
  url:
    PROJECT == "ticketak"
      ? "https://ticketak.com/"
      : "https://www.mytiketi.com/",
  logo:
    PROJECT == "ticketak"
      ? "https://ticketak.com/static/img/tt-logo.7304160.png"
      : "https://www.mytiketi.com/static/img/428%C3%97188_logo.082af5c.png",
  name:
    PROJECT == "ticketak" ? "Ticketak-Book movie tickets online" : "Mytiketi",
  sameAs:
    PROJECT == "ticketak"
      ? [
          "https://www.facebook.com/Ticketakuae",
          "https://www.linkedin.com/company/28768381/admin/"
        ]
      : ["https://www.facebook.com/mytiketinairobi/"],
  contactPoint: [
    {
      "@type": "ContactPoint",
      telephone: PROJECT == "ticketak" ? "+971-588282746" : "+91 9833092524",
      contactType: "customer service",
      areaServed: "IN",
      availableLanguage:
        PROJECT == "ticketak"
          ? ["English", "Hindi", "Marathi", "Tamil", "Telugu", "Kannada"]
          : ["English"]
    }
  ]
};



// WEBPACK FOOTER //
// ./src/helper/constant.js